/** Google's encoded polyline (the format the Routes API answers in), both ways, with no dependencies. */

export interface LatLng {
  lat: number;
  lng: number;
}

export function decode(str: string): LatLng[] {
  const pts: LatLng[] = [];
  let i = 0;
  let lat = 0;
  let lng = 0;
  while (i < str.length) {
    for (const w of [0, 1]) {
      let r = 0;
      let sh = 0;
      let b: number;
      do {
        b = str.charCodeAt(i++) - 63;
        r |= (b & 31) << sh;
        sh += 5;
      } while (b >= 32);
      const d = r & 1 ? ~(r >> 1) : r >> 1;
      if (w) lng += d;
      else lat += d;
    }
    pts.push({ lat: lat / 1e5, lng: lng / 1e5 });
  }
  return pts;
}

export function encode(pts: LatLng[]): string {
  let out = '';
  let pLat = 0;
  let pLng = 0;
  const one = (v: number) => {
    let x = v < 0 ? ~(v << 1) : v << 1;
    while (x >= 0x20) {
      out += String.fromCharCode((0x20 | (x & 0x1f)) + 63);
      x >>= 5;
    }
    out += String.fromCharCode(x + 63);
  };
  for (const p of pts) {
    const lat = Math.round(p.lat * 1e5);
    const lng = Math.round(p.lng * 1e5);
    one(lat - pLat);
    one(lng - pLng);
    pLat = lat;
    pLng = lng;
  }
  return out;
}
